import {
  JaccardGda,
  JaccardVda,
  GdaScore,
  GdaScoreCurated,
  GdaScoreClinicalTrials,
  GdaScoreInferred,
  GdaScoreModels,
  GdaScoreLiterature,
  VdaScore,
  VdaScoreCurated,
  VdaScoreLiterature,
  VdaScoreBiobank,
  DiseaseSpecificityIndex as DiseaseSpecificityIndexComponent,
  DiseasePleiotropyIndex as DiseasePleiotropyIndexComponent,
  EvidenceIndex,
  MyScore,
} from './formulas';

export const jaccardGda = () => <JaccardGda />;
export const jaccardVda = () => <JaccardVda />;
export const gdaScore = () => <GdaScore />;
export const gdaScoreCurated = () => <GdaScoreCurated />;
export const gdaScoreClinicalTrials = () => <GdaScoreClinicalTrials />;
export const gdaScoreInferred = () => <GdaScoreInferred />;
export const gdaScoreModels = () => <GdaScoreModels />;
export const gdaScoreLiterature = () => <GdaScoreLiterature />;
export const vdaScore = () => <VdaScore />;
export const vdaScoreCurated = () => <VdaScoreCurated />;
export const vdaScoreLiterature = () => <VdaScoreLiterature />;
export const vdaScoreBiobank = () => <VdaScoreBiobank />;
export const myScore = () => <MyScore />;
export const evidenceIndex = () => <EvidenceIndex />;

export const DiseaseSpecificityIndex = () => <DiseaseSpecificityIndexComponent />;
export const DiseasePleiotropyIndex = () => <DiseasePleiotropyIndexComponent />;

export {
  JaccardGda,
  JaccardVda,
  GdaScore,
  GdaScoreCurated,
  GdaScoreClinicalTrials,
  GdaScoreInferred,
  GdaScoreModels,
  GdaScoreLiterature,
  VdaScore,
  VdaScoreCurated,
  VdaScoreLiterature,
  VdaScoreBiobank,
  EvidenceIndex,
  MyScore,
};

export {
  DiseaseSpecificityIndex as DiseaseSpecificityIndexComponent,
  DiseasePleiotropyIndex as DiseasePleiotropyIndexComponent,
};

export type { FormulaComponentProps } from './types/index';
export * from './constants';